import { ReactNode } from 'react';
import { useFlagExperiment } from '../featureFlags';

function ExperimentsProvider({ children }: { children: ReactNode }) {
    useFlagExperiment('lite-plan-price-change-test', false, { useCache: true, skipAnalytics: false });
    return <>{children}</>;
}

export default ExperimentsProvider;
